export class SearchModel {
    constructor(public searchInput: string){}
}